import { all, put, call, takeEvery } from 'redux-saga/effects'
import axios from 'axios'
import * as actions from './actions'

function* loadMaterialQuota(action) {
  const {
    data: {
      page,
      page_size,
      order_by,
      order_type,
      accessToken,
      company_id,
      filter_obj,
      type,
      file_value_pdf,
      limit_export,
      material_visibility,
      location_visibility,
    },
  } = action.payload

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-material-quota/management-quota-list`,
      {
        page,
        page_size,
        order_by,
        order_type,
        company_id,
        filter_obj,
        type,
        file_value_pdf,
        limit_export,
        material_visibility,
        location_visibility,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )
    yield put(actions.loadMaterialQuota.success(res.data, page))
  } catch (err) {
    console.log(err.message)
    yield put(actions.loadMaterialQuota.failure())
  }
}

function* exportMaterialQuota(action) {
  const {
    data: {
      page,
      page_size,
      order_by,
      order_type,
      accessToken,
      company_id,
      filter_obj,
      type,
      file_value_pdf,
      limit_export,
      material_visibility,
      location_visibility,
    },
  } = action.payload

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-material-quota/management-quota-list`,
      {
        page,
        page_size,
        order_by,
        order_type,
        company_id,
        filter_obj,
        type,
        file_value_pdf,
        limit_export,
        material_visibility,
        location_visibility,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )
    yield put(actions.exportMaterialQuota.success(res.data, page))
    const sftpPath = res.data.data
    const downloadRes = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/download-report`,
      { sftp_path: sftpPath },
      { headers: { Authorization: `Bearer ${accessToken}` }, responseType: 'blob' },
    )
    const ext = sftpPath.split('.').pop().toLowerCase()
    const mimeType = ext === 'csv' ? 'text/csv' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    const blob = new Blob([downloadRes.data], { type: mimeType })
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = sftpPath.split('/').pop()
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    window.URL.revokeObjectURL(url)
  } catch (err) {
    console.log(err.message)
    yield put(actions.exportMaterialQuota.failure())
  }
}

function* loadMaterialQuotaDetail(action) {
  const {
    data: { material_quota_id, location_visibility, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-material-quota/get-material-quota-detail`,
      { material_quota_id, location_visibility },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.loadMaterialQuotaDetail.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.loadMaterialQuotaDetail.failure())
  }
}

function* materialQuotaManagement(action) {
  const {
    data: { material_quota_id, isupply_do_list, accessToken },
    loading,
  } = action.payload

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-material-quota/management-quota`,
      {
        material_quota_id,
        isupply_do_list,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )
    loading(res.data)
    yield put(actions.materialQuotaManagement.success(res.data))
  } catch (err) {
    yield put(actions.materialQuotaManagement.failure())
  }
}

// *load ข้อมูลต้นแหล่ง
function* materialQuotaLoadLocation(action) {
  const {
    data: { location_visibility, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-material-quota/get-origin-location`,
      { location_visibility },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.materialQuotaLoadLocation.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.materialQuotaLoadLocation.failure())
  }
}

// *load ข้อมูลวัตถุดิบ
function* materialQuotaLoadRawMaterial(action) {
  const {
    data: { material_visibility, locations_id, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-material-quota/get-material`,
      { material_visibility, locations_id },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.materialQuotaLoadRawMaterial.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.materialQuotaLoadRawMaterial.failure())
  }
}

export default function* watchMaterialQuota() {
  yield all([
    takeEvery(actions.LOAD_MATERIAL_QUOTA.REQUEST, loadMaterialQuota),
    takeEvery(actions.EXPORT_MATERIAL_QUOTA.REQUEST, exportMaterialQuota),
    takeEvery(
      actions.LOAD_MATERIAL_QUOTA_DETAIL.REQUEST,
      loadMaterialQuotaDetail
    ),
    takeEvery(
      actions.MATERIAL_QUOTA_MANAGEMENT.REQUEST,
      materialQuotaManagement
    ),
    takeEvery(
      actions.MATERIAL_QUOTA_LOCATION.REQUEST,
      materialQuotaLoadLocation
    ),
    takeEvery(
      actions.MATERIAL_QUOTA_RAW_MATERIAL.REQUEST,
      materialQuotaLoadRawMaterial
    ),
  ])
}
export {
  loadMaterialQuota,
  exportMaterialQuota,
  loadMaterialQuotaDetail,
  materialQuotaManagement,
  materialQuotaLoadLocation,
  materialQuotaLoadRawMaterial,
}
